import 'core-js'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

// Core UIKIT  - Includes css and javascript
import 'uikit'

// Style Overrides
import 'intro.js/introjs.css'
import 'static/less/theme.less'
import 'static/less/hackedu.less'
import 'static/less/hackedu-uikit.less'
import 'static/less/new_theme.less'

// Config
import store, { history } from 'app/state/store'

// Containers
import App from 'app/views/containers/App'


ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app'),
)
